import { render, staticRenderFns } from "./BackgroundInfoView.vue?vue&type=template&id=efb15ebc&scoped=true&"
import script from "./BackgroundInfoView.vue?vue&type=script&lang=js&"
export * from "./BackgroundInfoView.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundInfoView.vue?vue&type=style&index=0&id=efb15ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb15ebc",
  null
  
)

export default component.exports